module.exports = __webpack_public_path__ + "static/media/virtual-events-4.a55bc33b.jpg";